import { memo } from "react";
import { Mic, MessageSquareText } from "lucide-react";

import type { InputMode } from "@/features/tutor/utils/chatSettingsPersistence";

const MODES = [
  { value: "voice", Icon: Mic, label: "Voice mode" },
  { value: "chat", Icon: MessageSquareText, label: "Chat mode" },
] as const;

const ModeToggle = ({
  mode,
  onChange,
}: {
  mode: InputMode;
  onChange: (mode: InputMode) => void;
}) => (
  <div
    role="group"
    aria-label="Response mode"
    className="prevent-select relative flex h-[48px] rounded-[14px] bg-[#20202E] p-1"
  >
    <div
      aria-hidden
      className="absolute bottom-1 top-1 w-[calc(50%-4px)] rounded-[10px] bg-[#3C3C52] transition-[left] duration-[260ms] ease-[cubic-bezier(0.22,1,0.36,1)]"
      style={{ left: mode === "voice" ? 4 : "50%" }}
    />
    {MODES.map(({ value, Icon, label }) => (
      <button
        key={value}
        type="button"
        onClick={() => onChange(value)}
        aria-label={label}
        aria-pressed={mode === value}
        title={label}
        className={`relative z-[1] flex flex-1 items-center justify-center rounded-[10px] px-4 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70 ${
          mode === value ? "text-white" : "text-white/45"
        }`}
      >
        <Icon size={17} />
      </button>
    ))}
  </div>
);

export default memo(ModeToggle);
